import { Injectable, WritableSignal, signal } from '@angular/core';

export interface INotification {
  content: string;
  type: 'success' | 'error' | 'info' | 'warning';
  close?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class NotificationSystemService {
  private _message: WritableSignal<INotification> = signal<INotification>(undefined);

  constructor() {}

  public getNotification(): WritableSignal<INotification> {
    return this._message;
  }

  public setNotification(data: INotification) {
    this._message.set(data);
  }
}
